import React from 'react';
import './Checkbox.css';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
  error?: string;
}

export function Checkbox({ label, error, className = '', id, ...props }: CheckboxProps) {
  const checkId = id || `checkbox-${typeof label === 'string' ? label.toLowerCase().replace(/\s+/g, '-') : Math.random().toString(36).slice(2, 8)}`;
  return (
    <div className={`ui-checkbox-group ${error ? 'ui-checkbox-error' : ''} ${className}`}>
      <label htmlFor={checkId} className="ui-checkbox-label">
        <input type="checkbox" id={checkId} className="ui-checkbox" {...props} />
        <span className="ui-checkbox-mark" />
        {label && <span className="ui-checkbox-text">{label}</span>}
      </label>
      {error && <span className="ui-checkbox-error-text">{error}</span>}
    </div>
  );
}
